import { utils as clientUtils } from 'mage-client';

export const NAME = 'products-fe';
export const MERCHANT_FULL_ROLE = 'merchant-full';
export const COUNTRIES_TO_UPDATE_TOC = ['GB'];
export const COUNTRIES_WITH_ROUTING_NUMBER = ['US'];
export { EXPERIMENTS } from './experiments';

export {
  APP_PATHS,
  FLOW_STEP_PATHS,
  FLOW_THEMES,
  PRE_ASSESSMENT_STEP_PATHS,
  RECOLLECTION_STEP_PATHS,
  DOCUMENT_UPLOAD_STEP_PATHS,
  MERCHANT_VERIFICATION_STEP_PATHS,
} from './paths';

export const BANK_ACCOUNT_TYPES = {
  DEFAULT: 'default',
  ADDITIONAL: 'additional',
};

const a = x => `${NAME}/${x}`;
export const MERCHANT_NO_MID = a('merchants/no-mid');

export const PRODUCT_SELECTION_CLEAR_ERRORS = a('products/product-selection-clear-errors');

export const TERMS_ON_CHANGE = a('terms/terms-on-change');

export const API_KEY_DIALOG_OPEN = a('api-key-dialog/open');
export const API_KEY_DIALOG_CLOSE = a('api-key-dialog/close');
export const API_KEY_DOWNLOAD = a('api-key/download');

export const ADDRESIFY_CLEANUP = a('addresify/cleanup');

export const RECAPTCHA_EXECUTE = a('recaptcha/execute');
export const RECAPTCHA_SKIP = a('recaptcha/skip');
export const RECAPTCHA_SET_TOKEN = a('recaptcha/set-token');
export const RECAPTCHA_TOKEN_EXPIRED = a('recaptcha/token-expired');

export const INIT_APP = a('INIT_APP');
export const ON_CHANGE_FORM_VALUE = a('ON_CHANGE_FORM_VALUE');
export const CHANGE_LANGUAGE = a('CHANGE_LANGUAGE');
export const SET_CONFIRMED_COUNTRY_KEY = a('SET_CONFIRMED_COUNTRY_KEY');
export const SET_PRODUCTS = a('SET_PRODUCTS');

export const SELECT_MID = a('SELECT_MID');
export const SETUP_MID = a('SETUP_MID');
export const CLEAR_SELECTED_MID = a('CLEAR_SELECTED_MID');

const caps = {
  MERCHANTS_CREDENTIALS_GET: 'v2/merchants/credentials/get',
  MERCHANTS_CREDENTIALS_POST: 'v2/merchants/credentials/post',
  MERCHANTS_STATUS_GET: 'merchants/status/get',
  MERCHANTS_STEPS_ENABLE_PAYOUTS_POST: 'merchants/steps/enable-payouts/post',
  MERCHANTS_STEPS_ENABLE_TRANSACTIONS_POST: 'merchants/steps/enable-transactions/post',

  V2_COUNTRIES_GET: 'v2/countries/get',
  V2_ENTITY_TYPES_GET: 'v2/entity-types/get',
  V2_MERCHANTS_ADDITIONAL_PRODUCTS_POST: 'v2/merchants/additional-products/post',
  V2_MERCHANTS_BANK_ACCOUNT_PUT: 'v2/merchants/bank-accounts/put',
  V2_MERCHANTS_BUSINESS_DETAILS_PATCH: 'v2/merchants/business-details/patch',
  V2_MERCHANTS_GET: 'v2/merchants/get',
  V2_MERCHANTS_GET_ALL: 'v2/merchants/get/all',
  V2_MERCHANTS_PRODUCTS_PUT: 'v2/merchants/products/put',
  V2_MERCHANTS_STAKEHOLDERS_AND_OPERATIONAL_ADDRESS_PUT:
    'v2/merchants/stakeholders_and_operational_address/put',
  V2_MERCHANTS_STAKEHOLDERS_POST: 'v2/merchants/stakeholders/post',
  V2_MERCHANTS_STAKEHOLDERS_PUT: 'v2/merchants/stakeholders/put',
  V2_MERCHANTS_STORE_DETAILS_PUT: 'v2/merchants/store-details/put',
  V2_MERCHANTS_TERMS_AND_CONDITIONS_POST: 'v2/merchants/terms-and-conditions/post',
  V2_MERCHANTS_NEXT_STATUS_POST: 'v2/merchants/next-status/post',
  V2_MERCHANTS_RECOLLECTION_GET: 'v2/merchants/recollection/get',
  V2_MERCHANTS_RECOLLECTION_PUT: 'v2/merchants/recollection/put',
  V2_MERCHANTS_RECOLLECTION_POST: 'v2/merchants/recollection/post',
  V2_MERCHANTS_PHONE_NUMBER_POST: 'v2/merchants/phone-number/post',
  V2_MERCHANTS_PHONE_NUMBER_GET: 'v2/merchants/phone-number/get',
  V2_MERCHANTS_CONFIRM_COPY: 'v2/merchants/confirm-copy',
  V2_MERCHANTS_FIRST_TRANSACTION_GET: 'v2/merchants/first-transaction/get',

  V2_MERCHANTS_MERCHANT_VERIFICATION_POST: 'v2/merchants/merchant-verification/post',

  V2_OPTIONS_GET: 'v2/options/get',
  V2_PARTNERS_GET: 'v2/partners/mors/get',
  V2_ORGANIZATION_ENTITY_TYPES_GET: 'v2/organization-entity-types/get',
  V2_PLATFORMS_GET: 'v2/platforms/get',
  V2_PRODUCTS_GET: 'v2/products/get',
  V2_WIDGET_TOKEN_GET: 'v2/widget/token/get',

  V2_PRE_ASSESSMENT_GET: 'v2/merchants/pre-assessment/get',
  V2_PRE_ASSESSMENT_PATCH: 'v2/merchants/pre-assessment/patch',
  V2_PRE_ASSESSMENT_UNDERWRITING_STATUS_GET: 'v2/merchants/pre-assessment/underwriting-status/get',
  V2_KYM_PRE_ASSESSMENT_GET: 'v2/merchants/kym-pre-assessment/get',
  V2_KYM_PRE_ASSESSMENT_POST: 'v2/merchants/kym-pre-assessment/post',

  // document upload
  V2_DOC_UPLOAD: 'v2/merchants/doc/post',
  V2_DOC_LIST: 'v2/merchants/doc/get',
  V2_DOC_DELETE: 'v2/merchants/doc/delete',
  V2_DOC_TOKEN_INFO: 'v2/merchants/doc/tokenInfo/get',
  V2_DOC_TOKEN_COMPLETE: 'v2/merchants/doc/tokenComplete/post',
  V2_DOC_UPLOAD_COMPLETE: 'v2/merchants/doc/uploadComplete/post',

  ADDRESIFY_SUGGESTIONS: 'v2/addressify/suggestions/post',

  // New signup
  CAPABILITIES: 'capabilities/get',
  COUNTRIES_GET: 'v2/countries/get',
  PLATFORMS_GET: 'v2/platforms/get',
  PRODUCTS_GET: 'v2/products/get',
  SPECIAL_OFFER_GET: 'v2/special-offer/get',
  SETUP_POST: 'v2/setup/post',
  LEAD_POST: 'v2/lead/post',

  // experimentation
  EXPERIMENT: 'experiment',
  EXPERIMENTS_GET: 'experiments/get',
  FEATURE_CONFIG_GET: 'features-config/get',

  // fresh chat
  FRESH_CHAT_OPERATING_HOURS: 'fresh-chat/operating-hours',

  // BPC
  BPC_GET: 'v2/bpc/get',
  BPC_PATCH: 'v2/bpc/patch',
  BPC_INITIATE_UNDERWRITING: 'v2/bpc/initiateUnderwriting',
  BPC_SUBMIT_TERMS_AND_CONDITIONS: 'v2/bpc/submitTermsAndConditions',
  BPC_ASSOCIATE_USER: 'v2/bpc/associateUser',
};

export const CAPS = clientUtils.desiredCapabilities(caps);

export enum FEATURES_ENUM {
  SHOW_PRODUCTS_MAINTENANCE_MODE = 'show_products_maintenance_mode',
  SHOW_SIGNUP_MAINTENANCE_MODE = 'show_signup_maintenance_mode',
  SHOW_PRODUCTS_SUMMARY_NOTICE = 'show_products_summary_notice',
  FRESH_CHAT = 'fresh-chat', // it is an experiment
  PHONE_NUMBER_COLLECTION = 'phone_number_for_support_collection',
  RECAPTCHA_V3 = 'recaptcha-v3',
  SHOW_FRESH_CHAT = 'show_fresh_chat',
  FORCE_ANALYTICS_EVENTS_LOGGING = 'force_analytics_events_logging',
  FORCE_FIELD_VALIDATION = 'force_field_validation',
  SKIP_RECAPTCHA_CHALLENGE = 'skip_recaptcha_challenge',
  INTEGRATION_GUIDES_PLATFORMS_DISABLED = 'disable-integration-guides-platforms',
  SUPPORT_LOCAL_UK_BANK_ACCOUNTS = 'support_local_uk_bank_accounts',
  SEND_DOCUMENT_UPLOAD_DATA_TO_UNDERWRITING = 'send_document_upload_data_to_underwriting',
  PSP_PARTNERS = 'psp_partners',
  SUPPORT_LOCAL_SE_BANK_ACCOUNTS = 'support_local_se_bank_accounts',
}

export const FEATURES: Record<string, FEATURES_ENUM> = {
  SHOW_PRODUCTS_MAINTENANCE_MODE: FEATURES_ENUM.SHOW_PRODUCTS_MAINTENANCE_MODE,
  SHOW_SIGNUP_MAINTENANCE_MODE: FEATURES_ENUM.SHOW_SIGNUP_MAINTENANCE_MODE,
  SHOW_PRODUCTS_SUMMARY_NOTICE: FEATURES_ENUM.SHOW_PRODUCTS_SUMMARY_NOTICE,
  FRESH_CHAT: FEATURES_ENUM.FRESH_CHAT, // it is an experiment
  PHONE_NUMBER_COLLECTION: FEATURES_ENUM.PHONE_NUMBER_COLLECTION,
  RECAPTCHA_V3: FEATURES_ENUM.RECAPTCHA_V3,
  SHOW_FRESH_CHAT: FEATURES_ENUM.SHOW_FRESH_CHAT,
  FORCE_ANALYTICS_EVENTS_LOGGING: FEATURES_ENUM.FORCE_ANALYTICS_EVENTS_LOGGING,
  FORCE_FIELD_VALIDATION: FEATURES_ENUM.FORCE_FIELD_VALIDATION,
  SKIP_RECAPTCHA_CHALLENGE: FEATURES_ENUM.SKIP_RECAPTCHA_CHALLENGE,
  INTEGRATION_GUIDES_PLATFORMS_DISABLED: FEATURES_ENUM.INTEGRATION_GUIDES_PLATFORMS_DISABLED,
  SUPPORT_LOCAL_UK_BANK_ACCOUNTS: FEATURES_ENUM.SUPPORT_LOCAL_UK_BANK_ACCOUNTS,
  SEND_DOCUMENT_UPLOAD_DATA_TO_UNDERWRITING:
    FEATURES_ENUM.SEND_DOCUMENT_UPLOAD_DATA_TO_UNDERWRITING,
  PSP_PARTNERS: FEATURES_ENUM.PSP_PARTNERS,
  SUPPORT_LOCAL_SE_BANK_ACCOUNTS: FEATURES_ENUM.SUPPORT_LOCAL_SE_BANK_ACCOUNTS,
};

export const COOKIES = {
  PARTNER_WIDGET: 'X-KLARNA-PARTNER-WIDGET',
  WIDGET_TOKEN: 'X-KLARNA-WIDGET-TOKEN',
  ONBOARDING_LANGUAGE: {
    NAME: 'onboarding_language',
  },
  SETUP_DATA: {
    NAME: 'setup_data',
    EXPIRES: 1, // days
  },
  CONFIRMED_COUNTRY: {
    NAME: 'confirmed_country',
    EXPIRES: 1, // days
  },
};

export const HEADER_NO_CACHE = { 'Cache-Control': 'no-cache' };

export const PLATFORMS_TYPES = {
  MANUAL_CONTACT: 'MANUAL_CONTACT',
  NATIVE: 'NATIVE',
  OTHER: 'OTHER',
  SUPPORTED: 'SUPPORTED',
  UNSUPPORTED: 'UNSUPPORTED',
  WITHOUT_LANDING_PAGE: 'WITHOUT_LANDING_PAGE',
};

export * from './preAssessment';
export * from './volumeSeparation';
export { globalStyles } from './styles';
export { ONBOARDING_QUERY_PARAMS } from './query';

export const REGIONS = {
  EU: 'eu',
  US: 'us',
  AP: 'ap',
};

export const LEAD_ONBOARDING_TYPES = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC',
};

export const PERSONAL_ID_DOCUMENT_TYPE = {
  SOCIAL_SECURITY_NUMBER_MASKED: 'SOCIAL_SECURITY_NUMBER_MASKED',
  SOCIAL_SECURITY_NUMBER: 'SOCIAL_SECURITY_NUMBER',
  PERSONAL_IDENTIFICATION_NUMBER: 'PERSONAL_IDENTIFICATION_NUMBER',
  PERSONAL_IDENTIFICATION_CODE: 'PERSONAL_IDENTIFICATION_CODE',
  BIRTH_NUMBER: 'BIRTH_NUMBER',
};

export const IS_ONBOARDING_APP = /^\/(products\/)?signup/.test(document.location.pathname);
export const IS_MERCHANT_VERIFICATION_REVIEW_INFO = /^\/(products\/)?merchant-verification\/review/.test(
  document.location.pathname,
);
export const IS_MERCHANT_VERIFICATION_WIDGET =
  /^\/(products\/)?merchant-verification/.test(document.location.pathname) &&
  !IS_MERCHANT_VERIFICATION_REVIEW_INFO;

export const IS_PSP_APP = /^\/(products\/)?psp/.test(document.location.pathname);
